import axios from "axios";
import { businessDay } from "../services/utility";

const BASE_URL = "/api";

export const handleApiData = async (params, dispatch, handler) => {
    /* handler can either be a params property or 3rd argument to function */
    if (handler) {
        params.handler = handler;
    }
    const url = `${BASE_URL}/handle`;
    const response = await axios.post(url, params);
    const { data } = response;
    /* data can either contain or consist of reducers array */
    const reducers = data.reducers ? data.reducers : data;
    for (const i in reducers) {
        const { type, payload } = reducers[i];
        dispatch({
            type,
            payload,
        });
    }
};

export const handleLocalData = async (data, dispatch) => {
    const reducers = Array.isArray(data) ? data : [data];
    for (const i in reducers) {
        const { type, payload } = reducers[i];
        dispatch({
            type,
            payload,
        });
    }
};

/* Following convenience functions are invoked multiple times. Each returns the
   promise from the call it wraps, so a caller that needs to wait for a write
   before refetching can. Without that, `await` on one of these resolved
   immediately and a refresh could overtake the write it was meant to show. */
export const initData = async dispatch => {
    /* the day this device calls today, so the totals that come back cover the
       same day a sale entered on it would be filed under */
    return handleApiData({ todayIs: businessDay() }, dispatch, "getData");
};

/* the admin Staff screen only -- see api/data/getAllStaff.js for why this does
   not go through getData */
export const getAllStaff = async dispatch => {
    return handleApiData({}, dispatch, "getAllStaff");
};

export const deleteStaff = async (staffId, dispatch) => {
    return handleApiData({ staffId }, dispatch, "deleteStaff");
};

/* shopId narrows the sales figures to one shop; omitted, they cover them all,
   which is how this behaved before shops existed */
export const getMonthlySales = async (reqMonth, dispatch, shopId) => {
    return handleApiData({ reqMonth, shopId }, dispatch, "getMonthlySales");
};

export const getMonthlyExpenses = async (month, dispatch) => {
    return handleApiData({ month }, dispatch, "getMonthlyExpenses");
};

export const getShopReport = async (month, dispatch) => {
    return handleApiData({ month }, dispatch, "getShopReport");
};

export const unsetAdminAlert = async dispatch => {
    handleLocalData(
        {
            type: "adminAlert",
            payload: "",
        },
        dispatch,
    );
};

/* one suspects this is obsolete */
export const logoutAdmin = async dispatch => {
    handleLocalData(
        [
            {
                type: "adminAlert",
                payload: {},
            },
            {
                type: "adminLoggedIn",
                payload: false,
            },
        ],
        dispatch,
    );
};

/* a correction to the days a staff member worked in a month; the rebuilt
   month comes back with the reply, so there is nothing to refetch */
export const saveStaffMonth = async (payload, dispatch) => {
    return handleApiData(payload, dispatch, "saveStaffMonth");
};
